module.exports = __webpack_public_path__ + "img/RealCasinos_2208x1242_2.612819de.png";